import { AbstractControl } from '@angular/forms';

export function validateWeekDays(control: AbstractControl): { [key: string]: boolean } | null {
  const result = Object.values(control.value).some((val) => val);
  return result ? null : { validateWeekDays: true };
}
